<!-- Header -->
<app-header></app-header>

<!-- Hero -->
<section id="inicio" class="section-pad" style="background-color: #f0eada;">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-12 col-lg-6">
        <h1 class="display-title mb-4">Velas Artesanales Argentina<br/>Hechas con Amor en Buenos Aires</h1>
        <p class="lead-text mb-4">Ilumina tus momentos con <strong>velas artesanales</strong> únicas de <strong>cera de soja</strong>. En velas.ar elaboramos cuidadosamente cada vela con materiales premium en <strong>Buenos Aires y Baradero</strong> para crear ambientes especiales. <strong>Velas aromáticas artesanales</strong> con envío a toda <strong>Argentina</strong>.</p>
        <div class="d-flex flex-wrap gap-3 mt-4">
          <a href="https://tienda.velas.ar" class="btn btn-primary-custom btn-custom">Explorar Tienda</a>
          <a href="#productos" class="btn btn-outline-custom btn-custom">Ver Productos</a>
        </div>
        <div class="divider-line"></div>
        <div class="d-flex flex-wrap align-items-center gap-4 small">
          <div class="d-flex align-items-center gap-2">
            <svg class="check-icon" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <span class="text-accent">100% Artesanal</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <svg class="check-icon" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <span class="text-accent">Materiales Premium</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <svg class="check-icon" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <span class="text-accent">Envío Nacional</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="glass-card p-5 text-center">
          <svg width="200" height="200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="mx-auto mb-4">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
          </svg>
          <h3 class="fw-bold mb-3">Arte en Cada Vela</h3>
          <p class="text-accent">Cada pieza es única y creada con dedicación. Transformamos tu espacio en un ambiente acogedor y luminoso.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Beneficios Cera de Soja -->
<section class="section-pad border-top" style="background-color: #f0eada; border-top: 2px solid #e0e0e0 !important;">
  <div class="container">
    <div class="row g-5 align-items-center">
      <div class="col-12 col-lg-6">
        <h3 class="section-title mb-4">¿Por Qué Velas de Cera de Soja?</h3>
        <p class="section-subtitle mb-4">Las <strong>velas de soja</strong> ofrecen múltiples ventajas sobre las velas tradicionales. Nuestras <strong>velas artesanales</strong> están hechas con <strong>cera de soja</strong> premium, ideal para tu hogar en Buenos Aires.</p>
        <ul class="list-unstyled">
          <li class="mb-3 d-flex align-items-start gap-3">
            <svg class="check-icon flex-shrink-0 mt-1" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <div>
              <strong>Quema Más Limpia</strong>
              <p class="text-accent mb-0 small">La <strong>cera de soja</strong> produce menos hollín que la parafina tradicional.</p>
            </div>
          </li>
          <li class="mb-3 d-flex align-items-start gap-3">
            <svg class="check-icon flex-shrink-0 mt-1" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <div>
              <strong>100% Natural</strong>
              <p class="text-accent mb-0 small"><strong>Velas naturales</strong> de origen vegetal, ecológicas y sostenibles.</p>
            </div>
          </li>
          <li class="mb-3 d-flex align-items-start gap-3">
            <svg class="check-icon flex-shrink-0 mt-1" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <div>
              <strong>Mayor Duración</strong>
              <p class="text-accent mb-0 small">Las <strong>velas de soja</strong> duran hasta 50% más que las velas convencionales.</p>
            </div>
          </li>
          <li class="mb-3 d-flex align-items-start gap-3">
            <svg class="check-icon flex-shrink-0 mt-1" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <div>
              <strong>Aromas Intensos</strong>
              <p class="text-accent mb-0 small">Las <strong>velas aromáticas</strong> de soja conservan mejor las fragancias.</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-12 col-lg-6">
        <div class="text-center p-4 border-2 border-dark">
          <h4 class="fw-bold mb-4">Zonas de Entrega</h4>
          <div class="row g-3">
            <div class="col-6">
              <div class="p-3 bg-light">
                <div class="fw-bold">Buenos Aires</div>
                <div class="text-accent small">Capital y GBA</div>
              </div>
            </div>
            <div class="col-6">
              <div class="p-3 bg-light">
                <div class="fw-bold">Baradero</div>
                <div class="text-accent small">Zona Norte</div>
              </div>
            </div>
            <div class="col-12">
              <div class="p-3 bg-light">
                <div class="fw-bold">Todo Argentina</div>
                <div class="text-accent small">Envío Nacional</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Productos -->
<section id="productos" class="section-pad" style="background-color: #f0eada;">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="section-title">Velas de Soja Artesanales en Buenos Aires</h2>
      <p class="section-subtitle">Descubre nuestra colección de <strong>velas artesanales</strong> de <strong>cera de soja</strong> diseñadas para crear ambientes únicos en tu hogar. Fabricadas en Argentina con los mejores materiales.</p>
    </div>
    <div class="row g-4">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="card-custom h-100 p-4">
          <svg class="feature-icon mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <h5 class="fw-bold mb-3">Velas de Cera de Soja</h5>
          <p class="text-accent mb-0">Velas artesanales de <strong>cera de soja</strong> con elegantes diseños. Cera de soja premium perfecta para cualquier ocasión. Envío a todo Argentina.</p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <div class="card-custom h-100 p-4">
          <svg class="feature-icon mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
          </svg>
          <h5 class="fw-bold mb-3">Velas Aromáticas Artesanales</h5>
          <p class="text-accent mb-0">Velas de soja con fragancias naturales que transforman tu espacio en Buenos Aires. <strong>Velas aromáticas</strong> con esencias premium disponibles en diversos aromas.</p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <div class="card-custom h-100 p-4">
          <svg class="feature-icon mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
          </svg>
          <h5 class="fw-bold mb-3">Velas Decorativas Artesanales</h5>
          <p class="text-accent mb-0">Velas caseras con diseños exclusivos que combinan arte y funcionalidad. Piezas únicas hechas a mano en Baradero para decorar tu hogar.</p>
        </div>
      </div>
    </div>
    <div class="text-center mt-5">
      <a href="https://tienda.velas.ar" class="btn btn-outline-custom btn-custom">Ver Catálogo Completo</a>
    </div>
  </div>
</section>

<!-- Líneas -->
@if (highlightLineas.length > 0) {
  <section class="section-pad border-top" style="background-color: #f0eada; border-top: 2px solid #e0e0e0 !important;">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="section-title">Nuestras Líneas</h2>
        <p class="section-subtitle">
          Curamos cada línea para ofrecerte velas con identidad propia. Explorá nuestras propuestas para diferentes atmósferas.
        </p>
      </div>
      <div class="row g-4">
        @for (linea of highlightLineas; track linea.lineaSlug) {
          <div class="col-12 col-md-6 col-lg-4">
            <div class="card-custom h-100 p-4 d-flex flex-column justify-content-between">
              <div>
                <h3 class="fw-bold mb-3">{{ getNombreSinLinea(linea.nombre) }}</h3>
                <p class="text-accent mb-0">
                  {{ linea.descripcion || linea.metaDescription || 'Una selección exclusiva inspirada en momentos cotidianos.' }}
                </p>
              </div>
              <div class="mt-4">
                <a [routerLink]="['/coleccion', linea.lineaSlug]" class="btn btn-outline-custom btn-custom w-100">
                  Ver línea.
                </a>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>
}

<!-- Nosotros -->
<section id="nosotros" class="section-pad" style="background-color: #f0eada;">
  <div class="container">
    <div class="row g-5 align-items-center">
      <div class="col-12 col-lg-6">
        <div class="glass-card p-5">
          <svg width="100" height="100" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="mb-4">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
          <h2 class="section-title mb-4">Velas Artesanales Argentinas con Tradición</h2>
          <p class="section-subtitle mb-4">En velas.ar, fabricamos <strong>velas artesanales</strong> en <strong>Buenos Aires y Baradero</strong> para toda <strong>Argentina</strong>. Cada vela de <strong>cera de soja</strong> que creamos es el resultado de un proceso artesanal que combina técnicas tradicionales con materiales premium. Ofrecemos <strong>velas aromáticas artesanales</strong> y <strong>velas naturales</strong> con envío a todo el país.</p>
          <div class="divider-line"></div>
          <h4 class="fw-bold mb-3">Nuestros Valores</h4>
          <ul class="list-unstyled">
            <li class="mb-3 d-flex align-items-start gap-3">
              <svg class="check-icon flex-shrink-0 mt-1" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <div>
                <strong>Artesanía</strong>
                <p class="text-accent mb-0 small">Cada vela es hecha a mano con dedicación y cuidado excepcional.</p>
              </div>
            </li>
            <li class="mb-3 d-flex align-items-start gap-3">
              <svg class="check-icon flex-shrink-0 mt-1" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <div>
                <strong>Sustentabilidad</strong>
                <p class="text-accent mb-0 small">Utilizamos materiales eco-friendly y procesos sostenibles.</p>
              </div>
            </li>
            <li class="mb-3 d-flex align-items-start gap-3">
              <svg class="check-icon flex-shrink-0 mt-1" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <div>
                <strong>Calidad</strong>
                <p class="text-accent mb-0 small">Seleccionamos solo los mejores ingredientes para garantizar resultados excepcionales.</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="p-5">
          <h3 class="section-title mb-4">¿Por Qué Velas.ar?</h3>
          <p class="section-subtitle mb-4">Somos apasionados por crear experiencias que iluminen los momentos especiales. Cada vela cuenta una historia y queremos ser parte de la tuya.</p>
          <div class="row g-4 mt-4">
            <div class="col-6">
              <div class="text-center p-3 border-2 border-dark">
                <div class="display-4 fw-bold">100%</div>
                <p class="text-accent mb-0 small">Artesanal</p>
              </div>
            </div>
            <div class="col-6">
              <div class="text-center p-3 border-2 border-dark">
                <div class="display-4 fw-bold">100+</div>
                <p class="text-accent mb-0 small">Clientes</p>
              </div>
            </div>
            <div class="col-6">
              <div class="text-center p-3 border-2 border-dark">
                <div class="display-4 fw-bold">500+</div>
                <p class="text-accent mb-0 small">Velas Creadas</p>
              </div>
            </div>
            <div class="col-6">
              <div class="text-center p-3 border-2 border-dark">
                <div class="display-4 fw-bold">15+</div>
                <p class="text-accent mb-0 small">Aromas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Contacto -->
<section id="contacto" class="section-pad" style="background-color: #f0eada;">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="section-title">Velas Artesanales en Buenos Aires y Baradero</h2>
      <p class="section-subtitle">Contáctanos y descubre cómo nuestras <strong>velas artesanales</strong> de <strong>cera de soja</strong> pueden transformar tus momentos. Envío en Buenos Aires, Baradero y toda <strong>Argentina</strong>.</p>
    </div>
    <div class="row g-5">
      <div class="col-12 col-lg-6">
        <div class="glass-card p-5 h-100">
          <h3 class="fw-bold mb-4">Información de Contacto</h3>
          <div class="mb-4">
            <h5 class="fw-bold mb-2">Email</h5>
            <p class="text-accent mb-0">info@velas.ar</p>
          </div>
          <div class="mb-4">
            <h5 class="fw-bold mb-2">Teléfono</h5>
            <p class="text-accent mb-0">+54 9 3329-564190</p>
          </div>
          <div class="mb-4">
            <h5 class="fw-bold mb-3">CONÉCTATE</h5>
            <div class="d-flex gap-3">
              <a href="https://www.instagram.com/velas.ar_mayorista/" class="text-dark" style="text-decoration: none;" aria-label="Instagram">
                <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@velas.ar_mayorista" class="text-dark" style="text-decoration: none;" aria-label="TikTok">
                <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@velas.ar_mayorista" class="text-dark" style="text-decoration: none;" aria-label="YouTube">
                <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a href="https://ar.pinterest.com/velas_ar_mayorista/" class="text-dark" style="text-decoration: none;" aria-label="Pinterest">
                <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.374 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.403.041-3.441.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12 24c6.624 0 12-5.373 12-12S18.624.001 12 .001z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="glass-card p-5">
          <h3 class="fw-bold mb-4">Envíanos un Mensaje</h3>
          
          <!-- Mensaje de éxito -->
          @if (submitSuccess()) {
            <div class="alert alert-success alert-dismissible fade show" role="alert">
              <strong>¡Mensaje enviado!</strong> Te responderemos pronto.
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          }

          <!-- Mensaje de error -->
          @if (submitError()) {
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
              <strong>Error:</strong> {{ submitError() }}
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          }

          <form [formGroup]="contactoForm" (ngSubmit)="$event.preventDefault()" class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-bold">Nombre</label>
              <input 
                type="text" 
                class="form-control border-custom" 
                formControlName="nombre"
                placeholder="Tu nombre"
                [class.is-invalid]="contactoForm.get('nombre')?.invalid && contactoForm.get('nombre')?.touched">
              @if (getFieldError('nombre')) {
                <div class="invalid-feedback d-block">
                  {{ getFieldError('nombre') }}
                </div>
              }
            </div>
            <div class="col-md-6">
              <label class="form-label fw-bold">Email</label>
              <input 
                type="email" 
                class="form-control border-custom" 
                formControlName="email"
                placeholder="tu@correo.com"
                [class.is-invalid]="contactoForm.get('email')?.invalid && contactoForm.get('email')?.touched">
              @if (getFieldError('email')) {
                <div class="invalid-feedback d-block">
                  {{ getFieldError('email') }}
                </div>
              }
            </div>
            <div class="col-12">
              <label class="form-label fw-bold">Asunto</label>
              <input 
                type="text" 
                class="form-control border-custom" 
                formControlName="asunto"
                placeholder="¿En qué podemos ayudarte?">
            </div>
            <div class="col-12">
              <label class="form-label fw-bold">Mensaje</label>
              <textarea 
                class="form-control border-custom" 
                rows="5" 
                formControlName="mensaje"
                placeholder="Cuéntanos más sobre tu consulta..."
                [class.is-invalid]="contactoForm.get('mensaje')?.invalid && contactoForm.get('mensaje')?.touched"></textarea>
              @if (getFieldError('mensaje')) {
                <div class="invalid-feedback d-block">
                  {{ getFieldError('mensaje') }}
                </div>
              }
            </div>
            <div class="col-12">
              <!-- Validación del formulario antes de mostrar reCAPTCHA -->
              @if (contactoForm.invalid && contactoForm.touched) {
                <div class="alert alert-warning mb-3" role="alert">
                  Por favor, completa todos los campos requeridos antes de enviar.
                </div>
              }
              
              <button 
                class="btn btn-primary-custom btn-custom w-100" 
                type="button"
                (click)="handleSubmit()"
                [disabled]="isSubmitting() || contactoForm.invalid">
                @if (isSubmitting()) {
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Enviando...
                } @else {
                  Enviar Mensaje
                }
              </button>
              
            </div>
            
            <!-- Badge de reCAPTCHA visible y mensaje -->
            <div class="mt-4 pt-3 border-top border-2">
              <!-- Badge visual de reCAPTCHA -->
              <div class="text-center mb-3">
                <div class="d-inline-flex align-items-center gap-2 px-3 py-2 border border-dark rounded" style="background-color: #f8f9fa; border-width: 2px !important;">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="color: #25a745;">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    <path d="M9 12l2 2 4-4"/>
                </svg>
                  <span class="fw-bold" style="color: #ad5d56;">🔒 Protegido por reCAPTCHA</span>
                </div>
              </div>
              
              <!-- Información reCAPTCHA -->
              <div class="text-center">
                <small class="text-accent d-flex flex-wrap align-items-center justify-content-center gap-1" style="font-size: 0.75rem; line-height: 1.5;">
                  Este sitio está protegido por reCAPTCHA. 
                  <a href="https://policies.google.com/privacy" class="text-accent" style="text-decoration: underline;">Política de Privacidad</a>
                  y
                  <a href="https://policies.google.com/terms" class="text-accent" style="text-decoration: underline;">Términos de Servicio</a>
                  de Google.
                </small>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Final -->
<section class="section-pad" style="background-color: #f0eada;">
  <div class="container">
    <div class="glass-card p-5 text-center">
      <h2 class="section-title mb-4">Velas de Soja Artesanales en Argentina</h2>
      <p class="section-subtitle mb-5">Descubre nuestra tienda online de <strong>velas artesanales</strong> y encuentra la <strong>vela de soja</strong> perfecta para crear el ambiente que buscas. Envío a Buenos Aires, Baradero y toda Argentina.</p>
      <div class="d-flex flex-wrap justify-content-center gap-3">
        <a href="https://tienda.velas.ar" class="btn btn-primary-custom btn-custom">Visitar Tienda</a>
        <a href="#contacto" class="btn btn-outline-custom btn-custom">Contactar</a>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<app-footer></app-footer>

